// src/pages/ThreateningTextDetection.js
import React from 'react';

const ThreateningTextDetection = () => {
    return (
        <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
            <h1>Threatening Text Detection Model</h1>

            <p>
                I built a machine learning pipeline to detect threatening language in comments. It started with a heavily imbalanced dataset (less than 5% labelled as threats), so the first job was thoughtful sampling and rebalancing. Then came tokenisation (using Moses and NLTK), TF-IDF vectorisation, and finally model training using a Random Forest classifier.
            </p>

            <h2>What I Built</h2>
            <ul>
                <li>
                    <strong>Data Engineering:</strong> Cleaned and sampled 10,000+ labelled comments, manually balancing the class distribution to improve learning from rare threat cases.
                </li>
                <li>
                    <strong>Text Processing:</strong> Used Moses and Treebank tokenisers, with stopword filtering and TF-IDF vectorisation on 10k features.
                </li>
                <li>
                    <strong>Model Training:</strong> Trained multiple Random Forest models using <code>RandomizedSearchCV</code> for hyperparameter tuning. Focused on boosting recall for the minority class.
                </li>
                <li>
                    <strong>Evaluation:</strong> Precision, recall, and F1-score tracked across variations. Final model achieved ~82% recall for threats with &gt;99% accuracy overall.
                </li>
                <li>
                    <strong>Deployment:</strong> Model and vectoriser exported as Pickle files for live predictions. A custom function supports text input and real-time inference.
                </li>
            </ul>

            <h2>Why It Mattered</h2>
            <p>
                Detecting threatening language is subtle work. The model had to distinguish between aggressive wording and actual threats. Through iterative tuning and thoughtful feature engineering, I built a proof-of-concept lightweight, interpretable solution that can be used in moderation tools or public safety pipelines.
            </p>

            <a
                href="https://colab.research.google.com/drive/16R2r91xPen_UnfiZWK8qnJ0QTP7m3OJH"
                target="_blank"
                rel="noopener noreferrer"
                className="flow"
                style={{ marginTop: '24px', fontSize: '0.95rem' }}
            >
                Open Threatening Text Notebook
            </a>
        </main>
    );
};

export default ThreateningTextDetection;
